<template>
  <div id="app">
    <router-view/>                                             
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>.dataBox{
  background-color: #fff;
  margin:  15px 5px;
  padding:45px 34px 26px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue